import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import regeneratorRuntime from "/builds/lululemon/global-digital-tech/content-and-education/ecom-web-app/node_modules/next/dist/compiled/regenerator-runtime/runtime.js";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { composeDataMethods } from "@lululemon/mwa-utils";
import log from "@lululemon/ecom-cdp/src/lib/logger";
export var CdpSeoDataServiceContext = /*#__PURE__*/ React.createContext(null);
export function useCdpSeoDataService() {
    var context = React.useContext(CdpSeoDataServiceContext);
    if (!context) {
        throw new Error("This component must be wrapped in WithCdpSeods.");
    }
    return context;
}
var withCdpSeoDataService = function(Component) {
    var CdpSeoDataService = function(_param) {
        var isCdpSeoDataServiceEnabled = _param.isCdpSeoDataServiceEnabled, props = _object_without_properties(_param, [
            "isCdpSeoDataServiceEnabled"
        ]);
        var contextProps = {
            isCdpSeoDataServiceEnabled: isCdpSeoDataServiceEnabled
        };
        return /*#__PURE__*/ _jsx(CdpSeoDataServiceContext.Provider, {
            value: contextProps,
            children: /*#__PURE__*/ _jsx(Component, _object_spread({}, props))
        });
    };
    return composeDataMethods(Component, {
        prepareInitialPropsContext: function prepareInitialPropsContext(appContext) {
            return _async_to_generator(regeneratorRuntime.mark(function _callee() {
                var ref, ref1, ctx, isCdpSeoDataServiceEnabled, ref2, ref3, ref4;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ;
                            ctx = appContext.ctx || appContext;
                            isCdpSeoDataServiceEnabled = ((ref = ctx.req) === null || ref === void 0 ? void 0 : (ref1 = ref.headers) === null || ref1 === void 0 ? void 0 : ref1["x-lll-cdp-seods"]) || "false";
                            if ("object" !== "undefined") {
                                ;
                                ctx.isCdpSeoDataServiceEnabled = (ref2 = window.__NEXT_DATA__) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.props) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.layoutProps) === null || ref4 === void 0 ? void 0 : ref4.isCdpSeoDataServiceEnabled;
                            } else {
                                try {
                                    ctx.isCdpSeoDataServiceEnabled = JSON.parse(isCdpSeoDataServiceEnabled);
                                } catch (error) {
                                    // SSR log only if JSON.parse() fails.
                                    // Not a Sentry error since internal teams will invoke this exclusively.
                                    log.info({
                                        function: "withCdpSeoDataService()",
                                        message: "JSON Parsing of isCdpSeoDataServiceEnabled value of '".concat(isCdpSeoDataServiceEnabled, "'"),
                                        error: error
                                    });
                                    ctx.isCdpSeoDataServiceEnabled = false;
                                }
                            }
                        case 4:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }))();
        },
        getInitialProps: function(param) {
            var ctx = param.ctx;
            return {
                isCdpSeoDataServiceEnabled: ctx.isCdpSeoDataServiceEnabled
            };
        }
    })(/*#__PURE__*/ React.memo(CdpSeoDataService));
};
export default withCdpSeoDataService;
